module.exports = __webpack_public_path__ + "img/roboto+roboto_slab.9f06c566.png";